import { createFileRoute, redirect } from "@tanstack/react-router";

import { hasPermission } from "@/modules/auth/lib/permissions";
import { RepairCreatePage } from "@/modules/repairs/pages/RepairCreate.page";

export const Route = createFileRoute("/__authed/m/repairs/new")({
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (!hasPermission(user, "create_repairs")) {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: RepairCreatePage,
});
